import { useState } from 'react';
import { Loader2, RefreshCw, PlayCircle, ExternalLink } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const YouTubeVideosPanel = ({ authHeader, initialVideos = [], initialSyncedAt }) => {
  const [videos, setVideos] = useState(initialVideos);
  const [syncedAt, setSyncedAt] = useState(initialSyncedAt);
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState('');

  const syncNow = async () => {
    setSyncing(true); setError('');
    const res = await fetch(`${API_URL}/api/admin/support/youtube/sync`, { method: 'POST', headers: authHeader });
    const data = await res.json().catch(() => ({}));
    if (res.ok) { setVideos(data.videos); setSyncedAt(data.youtube_synced_at); } else setError(data.detail || 'Sync failed');
    setSyncing(false);
  };
  const toggle = async (v) => {
    const res = await fetch(`${API_URL}/api/admin/support/youtube/${v.video_id}/hidden`, {
      method: 'PUT', headers: { ...authHeader, 'Content-Type': 'application/json' }, body: JSON.stringify({ hidden: !v.hidden }),
    });
    if (res.ok) setVideos((prev) => prev.map((x) => (x.video_id === v.video_id ? { ...x, hidden: !v.hidden } : x)));
  };

  return (
    <div data-testid="youtube-videos-panel">
      <div className="flex items-center justify-between mb-1">
        <h3 className="text-white font-semibold">YouTube videos (auto-synced from @monkalgo)</h3>
        <button type="button" onClick={syncNow} disabled={syncing} className="text-xs text-[#a78bfa] flex items-center gap-1" data-testid="youtube-sync-now">
          {syncing ? <Loader2 size={12} className="animate-spin" /> : <RefreshCw size={12} />} Sync now
        </button>
      </div>
      <p className="text-white/40 text-xs mb-3" data-testid="youtube-synced-at">
        Refreshed every 6 hours{syncedAt ? `, last synced ${new Date(syncedAt).toLocaleString()}` : ''}. The agent only shares videos listed here and not hidden.
      </p>
      {error && <p className="text-red-400 text-xs mb-2" data-testid="youtube-sync-error">{error}</p>}
      <div className="space-y-1.5">
        {videos.map((v) => (
          <div key={v.video_id} className="flex items-center justify-between gap-3 text-sm" data-testid={`youtube-video-${v.video_id}`}>
            <span className={`flex items-center gap-2 min-w-0 ${v.hidden ? 'text-white/35 line-through' : 'text-white/75'}`}>
              <PlayCircle size={14} className="shrink-0" /><span className="truncate">{v.title}</span>
              <a href={v.url} target="_blank" rel="noopener noreferrer" className="text-[#a78bfa] shrink-0"><ExternalLink size={12} /></a>
            </span>
            <button type="button" onClick={() => toggle(v)} data-testid={`youtube-toggle-${v.video_id}`}
              className={`px-2.5 py-1 rounded-full text-xs font-medium shrink-0 ${v.hidden ? 'bg-white/10 text-white/50' : 'bg-[#10B981]/20 text-[#10B981]'}`}>
              {v.hidden ? 'Hidden from agent' : 'Agent can share'}
            </button>
          </div>
        ))}
        {!videos.length && <p className="text-white/40 text-xs">No videos synced yet. Tap Sync now.</p>}
      </div>
    </div>
  );
};
